import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Process from './components/Process';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/89057b92bf34c08c001dd5517bca6a4e/219dca12fd8acd291afc5e7ef7253dd5.png"
              alt="PatyPublicidad Logo"
              className="h-12 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a
              href="#inicio"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-pink-500' : 'text-white hover:text-pink-200'
              }`}
            >
              Inicio
            </a>
            <a
              href="#sobre-mi"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-pink-500' : 'text-white hover:text-pink-200'
              }`}
            >
              Sobre mí
            </a>
            <a
              href="#servicios"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-pink-500' : 'text-white hover:text-pink-200'
              }`}
            >
              Servicios
            </a>
            <a
              href="#portafolio"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-pink-500' : 'text-white hover:text-pink-200'
              }`}
            >
              Portafolio
            </a>
            <a
              href="#contacto"
              className={`px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-sm font-medium rounded-full hover:shadow-lg transition-all cursor-pointer whitespace-nowrap`}
            >
              Contáctame
            </a>
          </div>
        </div>
      </nav>

      <Hero />
      <About />
      <Services />
      <Portfolio />
      <Testimonials />
      <Process />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}
